
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ChangeProjectsList/ChangeProjectsList.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ChangeProjectsList.html');
        
        var script = require('./ChangeProjectsList.ts').default;
        module.exports = require('./ChangeProjectsList.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    